import React, { Component } from "react";
import DetectRTC from 'detectrtc'
// import io from "socket.io-client";
import RoomControl from "../../components/room/RoomControl";
import WhiteBoard from "../../components/room/WhiteBoard";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList'
import { withRouter } from 'react-router-dom';
import { getBoundingClientRect } from "../../utils/functions";
// import SocketServices from "../../utils/socket.services";
import { async } from "three";
import Room from "./Room";
import RequestToJoinMeeting from "../../components/widgets2/RequestToJoinMeeting";
import Responsive from "../../components/Responsive";
import { checkTranslation, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Modal from "../../components/Modal";
import FixedView from "../../components/FixedView";
import store from "../../stores/storeConfig";
import { nanoid } from "nanoid";
import socketServices from "../../utils/socket.services";
import RoomHubsList from "./RoomHubsList";
// import { zIndex } from "html2canvas/dist/types/css/property-descriptors/z-index";

// const ENDPOINT = "http://localhost:7900";
// io(ENDPOINT)

const detectRTCversion = "";
// const isWebRTCSupported = "";
// const isMobileDevice = "";
// const isTabletDevice = "";
const isIPadDevice = "";
const osName = "";
const browserName = "";
const browserVersion = "";


const isHttps = false; // must be the same on server.js
const peerLoockupUrl = 'https://extreme-ip-lookup.com/json/?key=demo2'; // get your API Key at https://extreme-ip-lookup.com
let backupIceServers = [{ urls: 'stun:stun.l.google.com:19302' }]; // backup iceServers


let myPeerId; // socket.id
let peerInfo = {}; // Some peer info
let peerGeo;
const notifyBySound = true;

let isRecScreenStream = false;
let localMediaStream; // my microphone / webcam
let signalingSocket;

let myPeerName;

let useVideo = true;
let useAudio = true;

let myHandStatus = false;


let peerConnections = {}; // keep track of our peer connections, indexed by peer_id == socket.io id

let peerConnection = null; // RTCPeerConnection

let fileDataChannels = {}; // keep track of our peer file sharing data channels

let chatDataChannels = {}; // keep track of our peer chat data channels

// let remoteMediaStream; // peers microphone / webcam

let remoteMediaControls = false; // enable - disable peers video player controls (default false)

let peerMediaElements = {}; // keep track of our peer <video> tags, indexed by peer_id

let allPeers = {}; // keep track of all peers in the room, indexed by peer_id == socket.io id

let isChatRoomVisible = false;

let isDocumentOnFullScreen = false;

let receiveFilePercentage;

let isCaptionBoxVisible = false;


// chat room elements
let msgerDraggable;
// let msgerHeader;
// let msgerTheme;
// let msgerCPBtn;
// let msgerClean;
// let msgerSaveBtn;
// let msgerClose;
// let msgerChat;
// let msgerEmojiBtn;
// let msgerInput;
// let msgerSendBtn;


let receivedSize = 0;

let chatRoomBtn;

let isButtonsVisible = false;


let isVideoOnFullScreen = false;

let myVideoStatusIcon;

let leftChatAvatar;
let rightChatAvatar;



let screenMaxFrameRate = 30;



// let isEnumerateAudioDevices = false;
// let isEnumerateVideoDevices = false;



class RoomVideo extends Component {

    state = {
        name: "",
        showAskName: true,
        showWhiteboard: false,
        selectPencil: true,
        WriteText: false,
        chooseImage: false,
        chooseUrl: false,
        currentView: 'tiled',
        userView: 'auto',
        cameras: [],
        positions: [],
        isScreenStreaming: false,
        viewType: 'spotlight',
        people: [
            { _id: 1, name: 'Paityn Carder', img: '/assets/icons/rooms/peoples/person2.svg' },
            { _id: 2, name: 'Madelyn Schleifer', img: '/assets/icons/rooms/peoples/person3.svg' },
            { _id: 3, name: 'Ruben Mango', img: '/assets/icons/rooms/peoples/person4.svg' },
            { _id: 4, name: 'Leo Herwitz', img: '/assets/icons/rooms/peoples/person5.svg' },
            { _id: 5, name: 'Jaylon Westervelt', img: '/assets/icons/rooms/peoples/person6.svg' },
            { _id: 6, name: 'Alfonso Baptista', img: '/assets/icons/rooms/peoples/person7.svg' },
            { _id: 7, name: 'Haylie Geidt', img: '/assets/icons/rooms/peoples/person8.svg' },
            { _id: 8, name: 'Lydia Dias', img: '/assets/icons/rooms/peoples/person9.svg' },
            { _id: 9, name: 'Livia Rhiel Madsen', img: '/assets/icons/rooms/peoples/person10.svg' },
        ],
        peopleList: false,
        option: [],
        emoji: [],

        hubsMore: [
            { title: 'Mute', icon: '/assets/icons/rooms/hubs/mute.svg', key: 'mute' },
            { title: 'Keek', icon: '/assets/icons/rooms/hubs/keek.svg', key: 'keek' },
        ]
    }



    componentDidMount() {
        let path = window.location.pathname
        path = path.split('/')
        path = path[path.length - 1]

        // console.log(path)
        this.setState({ path })
        // console.log('object')
        // this.props.handleJoinRequest()
        // this.props.handleConnect()
        // this.checkForTracks()
        this.checkCameras()
        this.checkWebRTCStats()
    }



    componentWillUnmount() {
        this.leaveRoom()
        clearInterval(this.interval)
        clearInterval(this.camerasInterval)
        clearInterval(this.checkStateInterval)
    }


    componentDidUpdate(prevProps) {
        if (this.props.width != prevProps.width || this.props.height != prevProps.height) {
            // console.log('setVIEWD1')
            this.setView()
        }
        // if (this.props.cameras != prevProps.cameras) {
        //     // console.log('stream changeds', this.props.cameras)
        // }
        // if (this.props.peopleList != prevProps.peopleList) {
        //     // console.log('setVIEWD2')
        //     this.setView()

        // }
        // if (this.props.information != prevProps.information) {
        //     // console.log('setVIEWD3')
        //     this.setView()

        // }
        // if (this.props.videoOff != prevProps.videoOff) {
        //     // console.log('setVIEWD4')
        //     setTimeout(() => {
        //         // console.log('locLVIDEO SOURCE', this.localVideo)
        //         this.localVideo.srcObject = this.props.localMediaStream;
        //         this.localVideo.onloadedmetadata = () => {
        //             this.localVideo?.play()
        //         }
        //     }, 50);
        // }

    }



    checkWebRTCStats = async (peerConnection) => {

        this.checkStateInterval = setInterval(async () => {

            let peerConnections = this.props.peerConnections
            if (!this.peerBitrates) {
                this.peerBitrates = {}
            }
            // for (let peer_id in peerConnections) {
            for (let [peer_id, peerConnection] of Object.entries(peerConnections)) {



                const stats = await peerConnection.getStats();

                stats.forEach(report => {


                    if (report.type === "inbound-rtp" && report.kind === "video") {
                        // console.log(`📡 Frames per second: ${report.framesPerSecond}`);
                        // console.log(`📉 Packets Lost: ${report.packetsLost}`);


                        // TO DO: check if undefined needs to be used or not
                        if ((report.framesPerSecond === 0 || report.framesPerSecond == undefined) || report.packetsLost > 10) {
                            console.warn("⚠️ Video may be frozen due to network issues!");

                            // this.restartVideoTrack(peer_id, peerConnection)
                        }
                    }


                    let currentBitrates = this.peerBitrates[peer_id] || 2500;


                    if (report.type === "outbound-rtp" && report.kind === "video") {
                        const { bytesSent, timestamp } = report;
                        const bitrateKbps = (bytesSent * 8) / 1000 / ((timestamp - report.timestamp) / 1000);

                        // console.log(`📡 Peer ${peer_id} Bitrate: ${bitrateKbps} kbps`);

                        if (bitrateKbps < 500) {
                            if (currentBitrates != 500) {
                                // console.warn(`⚠️ Peer ${peer_id} has weak network! Lowering quality.`);
                                this.adjustQuality(peerConnection, peer_id, 500, { width: 640, height: 360 }); // Lower quality
                            }
                        }
                        else if (bitrateKbps < 1800) {
                            if (currentBitrates != 1500) {
                                // console.log(`🔄 Peer ${peer_id} Medium Network → Switching to Medium Quality`);
                                this.adjustQuality(peerConnection, peer_id, 1500, { width: 1280, height: 720 });
                            }
                        }
                        else if (bitrateKbps > 2500) {
                            if (currentBitrates != 2500) {
                                // console.log(`🚀 Peer ${peer_id} has strong network! Increasing quality.`);
                                this.adjustQuality(peerConnection, peer_id, 2500, { width: 1920, height: 1080 }); // High quality
                            }
                        }
                    }
                });

            }

        }, 5000)
    }




    adjustQuality = async (peerConnection, peerId, newBitrate, newResolution) => {

        // console.log("adjustQuality", newBitrate, newResolution)
        if (!peerConnection) return;

        peerConnection.getSenders().forEach(async (sender) => {
            if (sender.track && sender.track.kind === "video") {

                const stream = sender.track.getSettings();

                // Ensure track resolution is updated
                if (stream.width !== newResolution.width || stream.height !== newResolution.height) {
                    const newStream = await navigator.mediaDevices.getUserMedia({
                        video: { width: newResolution.width, height: newResolution.height },
                    });

                    const newTrack = newStream.getVideoTracks()[0];
                    sender.replaceTrack(newTrack);

                    // console.log(`✅ Peer ${peerId}: Updated resolution to ${newResolution.width}x${newResolution.height}`);
                }


                const params = sender.getParameters();
                if (!params.encodings) params.encodings = [{}];

                params.encodings[0].maxBitrate = newBitrate * 1000; // Convert kbps to bps
                sender.setParameters(params)
                    .then(() => console.log(`🔄 Peer ${peerId}: Adjusted bitrate to ${newBitrate} kbps`))
                    .catch((err) => console.error(`Failed to set parameters for Peer ${peerId}:`, err));
            }
        });

        if (!this.currentBitrates) { this.currentBitrates = {} }
        if (!this.currentResolutions) { this.currentResolutions = {} }

        this.currentBitrates[peerId] = newBitrate
        this.currentResolutions[peerId] = newResolution

        // setPeerBitrates((prev) => ({ ...prev, [peerId]: newBitrate }));
        // setPeerResolutions((prev) => ({ ...prev, [peerId]: newResolution }));
    }









    checkCameras = () => {

        this.camerasInterval = setInterval(() => {

            let cameras = this.props.cameras

            if (!this.camerasCurrentTime) {
                this.camerasCurrentTime = {}
            }

            for (let i = 0; i < cameras.length; i++) {
                const camera = cameras[i];
                // console.log(this[camera.id])
                if (this[camera.id]) {

                    let newTime = this[camera.id].currentTime

                    // console.log("currentTime", newTime)
                    if (this.camerasCurrentTime[camera.id] == newTime) {
                        this.videoIsFreezed(camera)
                    } else {
                        this.camerasCurrentTime[camera.id] = newTime
                    }
                }

            }

        }, 3000)
    }



    // checkForTracks = () => {

    //     this.interval = setInterval(() => {
    //         let peerConnections = this.props.peerConnections
    //         for (let peer_id in peerConnections) {
    //             // this.props.peerConnections.forEach((peerConnection) => {
    //             let peerConnection = peerConnections[peer_id]
    //             // const senders = peerConnection.getSenders();
    //             // senders.forEach((sender) => {
    //             //     if (!sender.track) {
    //             //         console.log("Track missing, renegotiating...");
    //             //         console.log(sender)

    //             //         // socket.emit("request-renegotiation");
    //             //         peerConnections[peer_id].createOffer().then((offer) => {
    //             //             peerConnections[peer_id].setLocalDescription(offer).then(() => {
    //             //                 // socket.emit("offer", offer);
    //             //                 let channel = this.state.roomId
    //             //                 socketServices.socket.emit('roomOffer', { channel, offer, recipient: peer_id });
    //             //             })
    //             //         })
    //             //     }
    //             // });


    //             peerConnection.getReceivers().forEach((receiver) => {
    //                 const track = receiver.track;
    //                 // console.log(track)
    //                 if (track.readyState === "ended") {
    //                     console.warn("Track frozen! Replacing...");
    //                     // Request sender to re-add the track
    //                     //   socket.emit("request-track-replacement", { trackId: track.id });
    //                 }

    //                 // const stream = receiver.track?.enabled ? receiver.track : null;

    //                 // if (stream && !stream.active) {
    //                 //     console.warn(`Stream inactive for track:`);
    //                 //     console.warn(stream,receiver.track);

    //                 //     // socket.emit("peer-track-stopped", { trackId: receiver.track.id, kind: receiver.track.kind });
    //                 // }

    //             });
    //         }
    //         // })
    //         // }
    //     }, 5000);

    // }


    videoIsFreezed = (camera) => {

        console.log("videoIsFreezed", camera)
        if (camera.local) {

            if (camera.screenShare) {
                this.props.reloadScreenShare()
            } else {
                this.props.initUserMedia()
            }

        } else {

            // return
            this.askForVideoTrack(camera?.peer?.id)
            // TO DO: chekc if it is required or not
            // this.askForVideoTrack(camera.peer?.id)

        }

    }





    askForVideoTrack = (peerId) => {
        // console.log("restartVideoTrack",peerConnection)
        let peerConnection = this.props.peerConnections[peerId]

        if (peerConnection) {
            const senders = peerConnection.getSenders()
            // let peerId = peerConnection.id

            for (let c = 0; c < this.props.cameras.length; c++) {
                const camera = this.props.cameras[c];



                if (camera.peer?.id == peerId) {

                    let stream = camera.srcObject


                    if (!peerConnection || !stream) {
                        console.warn(`❌ Cannot restart video for peer ${peerId}, no stream found`);
                        return;
                    }

                    const videoTrack = stream.getVideoTracks()[0];

                    // console.log("videoTrack", videoTrack)

                    if (!videoTrack) {
                        // console.warn(`❌ No video track available for peer ${peerId}`);
                        return;
                    }


                    console.log("CAEMRA", camera)
                    this.props.sendToServer('askPeerForTrack', {
                        peer_id: peerId,
                        type: camera.screenShare ? 'screenShare' : 'camera',
                        kind: 'video',

                    });
                    // senders.forEach((sender) => {
                    //     if (sender.track && sender.track.kind === "video") {
                    //         console.log(`🔄 Replacing video track for peer ${peerId}...`);
                    //         sender.replaceTrack(videoTrack);
                    //     }
                    // });

                }

            }
        }


    }




    showSettingsModal = () => { this.settingsModal.showModal() }

    initSetView = (tryTime) => {

        // this.stream = stream;
        // let localMediaStream = this.stream

        // console.log('localmedia 1', localMediaStream);

        // this.setState({ cameras: cameras,localMediaStream }, () => {
        // console.log('HERETPEE')
        this.setView(() => {
            // console.log(this.props.localMediaStream);
            if (this.localVideo) {
                this.localVideo.srcObject = this.props.localMediaStream;
                this.localVideo.onloadedmetadata = () => {
                    this.localVideo.play()
                };
            } else {
                if (tryTime < 10) {
                    setTimeout(() => {
                        this.initSetView(tryTime)
                    }, 100);
                }
            }
            // this.localVideo.play()
            // console.log('local video in cpdm', this.localVideo);
        })

        // })
    }






    setView = (cb) => {

        // console.log("SETVIEW")
        let bound = getBoundingClientRect(this.camerasContainer)
        // console.log(bound)
        // this.presentView(this.props.cameras.length, bound.width, bound.height, () => {

        //     this.props.cameras.forEach(camera => {
        //         console.log('foreach camera', camera);
        //         if (camera.local) {
        //             console.log('camera local', true);
        //             this.localVideo.srcObject = camera.srcObject;
        //         } else {
        //             if (camera.id) {
        //                 console.log(true, 'attachMediaStream', camera.id, camera.srcObject);
        //                 this.props.attachMediaStream(camera.id, camera.srcObject);
        //             }
        //         }
        //     });

        //     if (cb)
        //         cb()
        // })

        // console.log('setView', this.props.cameras);

        if (this.props.cameras.length <= 2) {
            this.setState({ viewType: 'spotlight' }, () => {

                this.spotlightCalculator(this.props.cameras, bound.width, bound.height, () => {

                    this.props.cameras.forEach(camera => {
                        // console.log('foreach camera', camera);
                        if (camera.local) {
                            // console.log('this.props.cameras', this.props.cameras);
                            // console.log('camera loca121212l', camera.srcObject);
                            // this.localVideo.srcObject = camera.srcObject;
                        } else {
                            if (camera.id) {
                                // console.log(true, 'attachMediaStream', camera.id, camera.srcObject);
                                this.props.attachMediaStream(camera.id, camera.srcObject);
                            }
                        }
                    });

                    if (cb)
                        cb()
                })
            })
        }
        else {
            this.setState({ viewType: 'tile' }, () => {
                this.tileCalculator(this.props.cameras.length, bound.width, bound.height, () => {
                    this.props.cameras.forEach(camera => {
                        // console.log('foreach camera', camera);
                        if (camera.local && !camera.screenShare) {
                            // console.log('camera local', true);
                            // this.localVideo.srcObject = camera.srcObject;
                        } else {
                            if (camera.id) {
                                // console.log(true, 'attachMediaStream', camera.id, camera.srcObject);
                                this.props.attachMediaStream(camera.id, camera.srcObject);
                            }
                        }
                    });



                    if (cb)
                        cb()
                })
            })
        }
    }

    // setSpotLightView = (this.props.cameras.length, bound.width, bound.height, () => {

    // })
    presentView = (cameras, width, height, cb) => {
        let positions = []
        let position = {}
        let promises = []
        let leftPoint = width - 240
        let topPoint = height - 300

        for (let i = 0; i < cameras; i++) {
            promises.push(new Promise((resolve, reject) => {
                if (i == 0) {
                    position = { row: 1, col: 1, top: 10, left: 10, w: width, h: height }
                    positions.push(position)
                    resolve()
                }
                else {
                    position = { row: 1, col: 1, top: topPoint, left: leftPoint, w: 270, h: 150 }
                    positions.push(position)
                    topPoint += 150
                    resolve()
                }
            }))
        }
        Promise.all(promises).then(() => {
            this.setState({ positions }, () => {

                // console.log('positions', positions);
                cb()
            })
        })
    }
    spotlightCalculator = (cameras, width, height, cb) => {
        let positions = []
        let position = {}
        // let promises = []
        let leftPoint = width - 270
        let topPoint = height - 150
        for (let i = 0; i < cameras.length; i++) {
            let camera = cameras[i]
            // console.log(cameras,camera)
            // promises.push(new Promise((resolve, reject) => {

            if (cameras.length == 1) {
                position = { row: 1, col: 1, top: 10, left: 10, w: width, h: height }
                positions.push(position)
                // resolve()
            } else {

                if (camera.local && !camera.screenShare) {
                    // positions = []
                    position = { row: 1, col: 1, top: topPoint, left: leftPoint, w: 270, h: 150 }
                    positions.push(position)
                } else {
                    position = { row: 1, col: 1, top: 10, left: 10, w: width, h: height }
                    positions.push(position)
                }


                // resolve()
            }
            // }))
        }
        // Promise.all(promises).then(() => {
        this.setState({ positions }, () => {

            // console.log('positions', positions);
            cb()
        })
        // })
    }


    tileCalculator = (cameras, width, height, cb) => {
        let margin = 12

        let minSize = 110
        let possibilities = []
        let final = {}
        let positions = []

        let maxRows = Math.floor((height / (minSize + margin)))
        let maxCols = Math.floor((width / (minSize + margin)))

        // console.log(maxRows)
        // console.log(maxCols)

        let maxCameras = maxRows * maxCols

        if (cameras <= maxCameras) {
            maxCameras = cameras
        }

        for (let i = 1; i <= maxCameras; i++) {
            let j = Math.ceil(maxCameras / i)
            if (i <= maxRows && j <= maxCols) {
                possibilities.push({ rows: i, cols: j })
            }
        }


        possibilities.forEach((possibility, index) => {
            let res = this.calculatePossibility(possibility, cameras, width, height, margin, minSize)
            if (res.valid) {
                possibilities[index] = { ...possibility, ...res }
                if (final.area < res.area || !final.area) {
                    final = possibilities[index]
                }
            }

        });
        if (!final.area) {
            final = { h: height, w: width, rows: 1, cols: 1, ratio: width / height }
        }

        let topPoint = (height - (final.rows * final.h + (final.rows - 1 * margin))) / 2
        let leftPoint = (width - (final.cols * final.w + (final.cols - 1 * margin))) / 2


        for (let i = 0; i < maxCameras; i++) {
            let tRow = Math.floor((i) / final.cols)
            let tCol = i - (final.cols * tRow)
            let w = final.w - margin
            let h = final.h - margin
            let offset = 0

            if (tRow + 1 == final.rows && ((final.cols * final.rows) % maxCameras) != 0) {

                offset = ((final.cols * final.rows) - maxCameras)
                offset = (offset * (w + margin)) / 2

            }

            let top = topPoint + (tRow * h) + (tRow * margin)
            let left = leftPoint + offset + (tCol * w) + (tCol * margin)


            let position = { row: tRow, col: tCol, top, left, w, h }
            positions.push(position)

        }


        // console.log(positions)

        this.setState({ positions: positions }, () => {
            // this.localVideo.play()
            cb()
        })

    }


    calculatePossibility(possibility, cameras, width, height, margin, minSize) {
        let minRatio = 1
        let maxRatio = 1.8
        let ratio
        let rows = possibility.rows
        let cols = possibility.cols
        let valid = true

        let w = (width - ((cols - 1) * margin)) / cols
        let h = (height - ((rows - 1) * margin)) / rows

        ratio = w / h



        if (ratio > maxRatio) {
            ratio = maxRatio
            w = h * ratio
        }

        if (ratio < minRatio) {
            ratio = minRatio
            h = w / minRatio
        }


        if (w < minSize || h < minSize) {
            valid = false
        }

        return { valid, ratio, w, h, area: w * h }


    }










    /**
    * Get Signaling server URL
    * @returns {string} Signaling server URL
    */
    getSignalingServer = () => {

        console.log("signaling server")

        console.log('https://' + window.location.hostname)

        if (isHttps) {
            return 'https://' + window.location.hostname;
        }
        return 'http' + (window.location.hostname == 'localhost' ? '' : 's') + '://' + window.location.hostname;

    }


    /**
    * Get peer info using DetecRTC
    * https://github.com/muaz-khan/DetectRTC
    * @returns {object} peer info
    */

    getPeerInfo = () => {
        return {
            detectRTCversion: DetectRTC.version,
            isWebRTCSupported: DetectRTC.isWebRTCSupported,
            isMobileDevice: DetectRTC.isMobileDevice,
            isTabletDevice: this.isTabletDevice,
            isIPadDevice: isIPadDevice,
            osName: DetectRTC.osName,
            osVersion: DetectRTC.osVersion,
            browserName: DetectRTC.browser.name,
            browserVersion: DetectRTC.browser.version,
        };
    }


    /**
    * Get approximative peer geolocation
    * Get your API Key at https://extreme-ip-lookup.com
    */
    getPeerGeoLocation = async () => {
        // console.log('07. Get peer geo location');
        fetch(peerLoockupUrl)
            .then((res) => res.json())
            .then((outJson) => {
                peerGeo = outJson;
            })
        // .catch((err) => console.warn(err));
    }


    /**
    * Emit actions to all peers in the same room except yourself
    * @param {object} peerAction to all peers
    */
    emitPeersAction = async (peerAction) => {
        // if (!thereIsPeerConnections()) return;

        this.props.sendToServer('roomPeerAction', {
            room_id: this.props?.roomId,
            peer_name: this.props.myPeerName,
            peer_id: this.props.myPeerId,
            peer_use_video: useVideo,
            peer_action: peerAction,
            send_to_all: true,
        });
    }










    /**
    * Send async data to signaling server (server.js)
    * @param {string} msg msg to send to signaling server
    * @param {object} config data to send to signaling server
    */
    sendToServer = async (msg, config = {}) => {
        // console.log("COM: " + msg)
        // console.log(signalingSocket)
        signalingSocket.emit(msg, config);
    }


    /**
    * Peers exchange session descriptions which contains information about their audio / video settings and that sort of stuff. First
    * the 'offerer' sends a description to the 'answerer' (with type "offer"), then the answerer sends one back (with type "answer").
    * @param {object} config data
    */
    handleSessionDescription = (config) => {
        // console.log('Remote Session Description', config);

        let peer_id = config.peer_id;
        let remote_description = config.session_description;

        // https://developer.mozilla.org/en-US/docs/Web/API/RTCSessionDescription
        let description = new RTCSessionDescription(remote_description);

        // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/setRemoteDescription
        peerConnections[peer_id]
            .setRemoteDescription(description)
            .then(() => {
                // console.log('setRemoteDescription done!');
                if (remote_description.type == 'offer') {
                    // console.log('Creating answer');
                    // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/createAnswer
                    peerConnections[peer_id]
                        .createAnswer()
                        .then((local_description) => {
                            // console.log('Answer description is: ', local_description);
                            // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/setLocalDescription
                            peerConnections[peer_id]
                                .setLocalDescription(local_description)
                                .then(() => {
                                    this.props.sendToServer('roomRelaySDP', {
                                        peer_id: peer_id,
                                        session_description: local_description,
                                    });
                                    // console.log('Answer setLocalDescription done!');
                                })
                                .catch((err) => {
                                    // console.error('[Error] answer setLocalDescription', err);
                                    // console.log('error', 'Answer setLocalDescription failed ' + err);
                                });
                        })
                        .catch((err) => {
                            // console.error('[Error] creating answer', err);
                        });
                } // end [if type offer]
            })
            .catch((err) => {
                // console.error('[Error] setRemoteDescription', err);
            });
    }

    /**
    * Check if there is peer connections
    * @returns {boolean} true/false
    */
    thereIsPeerConnections = () => {
        if (Object.keys(this.props.peerConnections).length === 0) return false;
        return true;
    }

    /**
     * Count the peer connections
    * @returns peer connections count
    */
    countPeerConnections = () => {
        return Object.keys(this.props.peerConnections).length;
    }

    /**
    * Handle peers connection state
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/connectionstatechange_event
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/connectionState
    * @param {string} peer_id socket.id
    */
    // handlePeersConnectionStatus = async (peer_id) => {
    //     peerConnections[peer_id].onconnectionstatechange = function (event) {
    //         const connectionStatus = event.currentTarget.connectionState;
    //         const signalingState = event.currentTarget.signalingState;
    //         // console.log('[RTCPeerConnection] - CONNECTION', {
    //         //     peer_id: peer_id,
    //         //     connectionStatus: connectionStatus,
    //         //     signalingState: signalingState,
    //         // });
    //     };
    // }

    /**
    * https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/onicecandidate
    * @param {string} peer_id socket.id
    */
    // handleOnIceCandidate = async (peer_id) => {
    //     peerConnections[peer_id].onicecandidate = (event) => {
    //         if (!event.candidate) return;
    //         this.props.sendToServer('roomRelayICE', {
    //             peer_id: peer_id,
    //             ice_candidate: {
    //                 sdpMLineIndex: event.candidate.sdpMLineIndex,
    //                 candidate: event.candidate.candidate,
    //             },
    //         });
    //     };
    // }

    /**
    * Hide Video to specified peer in the room
    * @param {string} peer_id socket.id
    */
    handlePeerVideoBtn = (peer_id) => {
        if (!useVideo) return;
        let peerVideoBtn = document.getElementById(peer_id + '_videoStatus');
        peerVideoBtn.onclick = () => {
            // if (peerVideoBtn.className === 'fas fa-video') disablePeer(peer_id, 'video');
        };
    }

    // /**
    // * Send video - audio URL to specific peer
    // * @param {string} peer_id socket.id
    // */
    // handlePeerVideoAudioUrl = (peer_id) => {
    //     let peerYoutubeBtn = document.getElementById(peer_id + '_videoAudioUrl');
    //     peerYoutubeBtn.onclick = () => {
    //         sendVideoUrl(peer_id);
    //     };
    // }

    /**
    * Mute Audio to specific user in the room
    * @param {string} peer_id socket.id
    */
    handlePeerAudioBtn = (peer_id) => {
        let peerAudioBtn = document.getElementById(peer_id + '_audioStatus');
        peerAudioBtn.onclick = () => {
            // if (peerAudioBtn.className === 'fas fa-microphone') disablePeer(peer_id, 'audio');
        };
    }

    // /**
    // * Send Private Message to specific peer
    // * @param {string} peer_id socket.id
    // * @param {string} toPeerName peer name to send message
    // */
    // handlePeerPrivateMsg = (peer_id, toPeerName) => {
    //     let peerPrivateMsg = document.getElementById(peer_id + '_privateMsg');
    //     peerPrivateMsg.onclick = (e) => {
    //         e.preventDefault();
    //         Swal.fire({
    //             background: swalBackground,
    //             position: 'center',
    //             imageUrl: messageImg,
    //             title: 'Send private message',
    //             input: 'text',
    //             showCancelButton: true,
    //             confirmButtonText: `Send`,
    //             showClass: {
    //                 popup: 'animate__animated animate__fadeInDown',
    //             },
    //             hideClass: {
    //                 popup: 'animate__animated animate__fadeOutUp',
    //             },
    //         }).then((result) => {
    //             if (result.value) {
    //                 let pMsg = checkMsg(result.value);
    //                 if (!pMsg) return;
    //                 emitMsg(myPeerName, toPeerName, pMsg, true);
    //                 appendMessage(
    //                     myPeerName,
    //                     rightChatAvatar,
    //                     'right',
    //                     pMsg + '<br/><hr>Private message to ' + toPeerName,
    //                     true,
    //                 );
    //                 userLog('toast', 'Message sent to ' + toPeerName + ' 👍');
    //             }
    //         });
    //     };
    // }

    /**
    * Refresh video - chat image avatar on name changes: https://eu.ui-avatars.com/
    * @param {string} videoAvatarImageId element id
    * @param {string} peerName
    */
    setPeerAvatarImgName = (videoAvatarImageId, peerName) => {
        let videoAvatarImageElement = document.getElementById(videoAvatarImageId);
        // default img size 64 max 512
        let avatarImgSize = this.isMobileDevice ? 128 : 256;
        videoAvatarImageElement.setAttribute(
            'src',
            // avatarApiUrl + '?name=' + peerName + '&size=' + avatarImgSize + '&background=random&rounded=true',
        );
    }


    // /**
    // * Set Participant Video Status Icon and Title
    // * @param {string} peer_id socket.id
    // * @param {boolean} status of peer video
    // */
    // setPeerVideoStatus = (peer_id, status) => {
    //     let peerVideoAvatarImage = document.getElementById(peer_id + '_avatar');
    //     let peerVideoStatus = document.getElementById(peer_id + '_videoStatus');
    //     if (peerVideoAvatarImage) peerVideoAvatarImage.style.display = status ? 'none' : 'block';
    //     if (peerVideoStatus) {
    //         peerVideoStatus.className = 'fas fa-video' + (status ? '' : '-slash');
    //         // this.setTippy(peerVideoStatus, status ? 'Participant video is on' : 'Participant video is off', 'bottom');
    //         // status ? playSound('on') : playSound('off');
    //     }
    // }


    // /**
    // * Set nice tooltip to element
    // * @param {object} elem element
    // * @param {string} content message to popup
    // * @param {string} placement position
    // */
    // setTippy = (elem, content, placement) => {
    //     tippy(elem, {
    //         content: content,
    //         placement: placement,
    //     });
    // }


    /**
    * Handle aspect ratio
    * ['0:0', '4:3', '16:9', '1:1', '1:2'];
    *    0      1       2      3      4
    */
    // adaptAspectRatio = () => {
    //     let participantsCount = document.getElementById('videoMediaContainer').childElementCount;
    //     let desktop,
    //         mobile = 1;
    //     // desktop aspect ratio
    //     switch (participantsCount) {
    //         // case 1:
    //         //     desktop = 0; // (0:0)
    //         //     break;
    //         case 1:
    //         case 3:
    //         case 4:
    //         case 7:
    //         case 9:
    //             desktop = 2; // (16:9)
    //             break;
    //         case 5:
    //         case 6:
    //         case 10:
    //         case 11:
    //             desktop = 1; // (4:3)
    //             break;
    //         case 2:
    //         case 8:
    //             desktop = 3; // (1:1)
    //             break;
    //         default:
    //             desktop = 0; // (0:0)
    //     }
    //     // mobile aspect ratio
    //     switch (participantsCount) {
    //         case 3:
    //         case 9:
    //         case 10:
    //             mobile = 2; // (16:9)
    //             break;
    //         case 2:
    //         case 7:
    //         case 8:
    //         case 11:
    //             mobile = 1; // (4:3)
    //             break;
    //         case 1:
    //         case 4:
    //         case 5:
    //         case 6:
    //             mobile = 3; // (1:1)
    //             break;
    //         default:
    //             mobile = 3; // (1:1)
    //     }
    //     if (participantsCount > 11) {
    //         desktop = 1; // (4:3)
    //         mobile = 3; // (1:1)
    //     }
    //     // this.setAspectRatio(isMobileDevice ? mobile : desktop);
    // }


    /**
    * On video player click, go on full screen mode ||
    * On button click, go on full screen mode.
    * Press Esc to exit from full screen mode, or click again.
    * @param {string} videoId uuid video element
    * @param {string} videoFullScreenBtnId uuid full screen btn
    * @param {string} peer_id socket.id
    */
    handleVideoPlayerFs = (videoId, videoFullScreenBtnId, peer_id = null) => {
        let videoPlayer = document.getElementById(videoId);
        let videoFullScreenBtn = document.getElementById(videoFullScreenBtnId);

        // handle Chrome Firefox Opera Microsoft Edge videoPlayer ESC
        videoPlayer.addEventListener('fullscreenchange', (e) => {
            // if Controls enabled, or document on FS do nothing
            if (videoPlayer.controls || isDocumentOnFullScreen) return;
            let fullscreenElement = document.fullscreenElement;
            if (!fullscreenElement) {
                videoPlayer.style.pointerEvents = 'auto';
                isVideoOnFullScreen = false;
                // console.log("Esc FS isVideoOnFullScreen", isVideoOnFullScreen);
            }
        });

        // handle Safari videoPlayer ESC
        videoPlayer.addEventListener('webkitfullscreenchange', (e) => {
            // if Controls enabled, or document on FS do nothing
            if (videoPlayer.controls || isDocumentOnFullScreen) return;
            let webkitIsFullScreen = document.webkitIsFullScreen;
            if (!webkitIsFullScreen) {
                videoPlayer.style.pointerEvents = 'auto';
                isVideoOnFullScreen = false;
                // console.log("Esc FS isVideoOnFullScreen", isVideoOnFullScreen);
            }
        });

        // on button click go on FS mobile/desktop
        videoFullScreenBtn.addEventListener('click', (e) => {
            gotoFS();
        });

        // on video click go on FS
        videoPlayer.addEventListener('click', (e) => {
            // not mobile on click go on FS or exit from FS
            if (!this.isMobileDevice) {
                gotoFS();
            } else {
                // mobile on click exit from FS, for enter use videoFullScreenBtn
                if (isVideoOnFullScreen) handleFSVideo();
            }
        });

        function gotoFS() {
            // handle remote peer video fs
            if (peer_id !== null) {
                let remoteVideoStatusBtn = document.getElementById(peer_id + '_videoStatus');
                if (remoteVideoStatusBtn.className === 'fas fa-video') {
                    handleFSVideo();
                } else {
                    showMsg();
                }
            } else {
                // handle local video fs
                if (myVideoStatusIcon.className === 'fas fa-video' || this.state.isScreenStreaming) {
                    handleFSVideo();
                } else {
                    showMsg();
                }
            }
        }

        function showMsg() {
            // console.log('toast', 'Full screen mode work when video is on');
        }

        function handleFSVideo() {
            // if Controls enabled, or document on FS do nothing
            if (videoPlayer.controls || isDocumentOnFullScreen) return;

            if (!isVideoOnFullScreen) {
                if (videoPlayer.requestFullscreen) {
                    // Chrome Firefox Opera Microsoft Edge
                    videoPlayer.requestFullscreen();
                } else if (videoPlayer.webkitRequestFullscreen) {
                    // Safari request full screen mode
                    videoPlayer.webkitRequestFullscreen();
                } else if (videoPlayer.msRequestFullscreen) {
                    // IE11 request full screen mode
                    videoPlayer.msRequestFullscreen();
                }
                isVideoOnFullScreen = true;
                videoPlayer.style.pointerEvents = 'none';
                // console.log("Go on FS isVideoOnFullScreen", isVideoOnFullScreen);
            } else {
                if (document.exitFullscreen) {
                    // Chrome Firefox Opera Microsoft Edge
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    // Safari exit full screen mode ( Not work... )
                    document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    // IE11 exit full screen mode
                    document.msExitFullscreen();
                }
                isVideoOnFullScreen = false;
                videoPlayer.style.pointerEvents = 'auto';
                // console.log("Esc FS isVideoOnFullScreen", isVideoOnFullScreen);
            }
        }
    }


    /**
    * Handle peer audio volume
    * @param {object} data peer audio
    */
    handlePeerVolume = (data) => {
        let peer_id = data.peer_id;
        let element = document.getElementById(peer_id + '_pitch_bar');
        let remoteVideoWrap = document.getElementById(peer_id + '_videoWrap');
        let remoteVideoBorder = document.documentElement.style.getPropertyValue('--elem-border-color');
        let volume = data.volume + 25; //for design purpose
        if (!element) return;
        if (volume > 50) {
            element.style.backgroundColor = 'orange';
        }
        element.style.height = volume + '%';
        remoteVideoWrap.style.border = '1px solid rgb(255 255 255 / 32%)';
        setTimeout(function () {
            element.style.backgroundColor = '#19bb5c';
            element.style.height = '0%';
            remoteVideoWrap.style.border = remoteVideoBorder;
        }, 700);
    }



    /**
    * Handle text transcript getting from peers
    * @param {object} config data
    */
    handleDataChannelSpeechTranscript = (config) => {
        this.handleSpeechTranscript(config);
    }


    /**
    * Show caption box draggable on center screen position
     */
    showCaptionDraggable = () => {
        // playSound('newMessage');
        if (this.isMobileDevice) {
            // buttonsBar.style.display = 'none';
            isButtonsVisible = false;
        }
        isCaptionBoxVisible = true;
        // only for desktop
    }




    /**
    * Show msger draggable on center screen position
    */
    showChatRoomDraggable = () => {
        // playSound('newMessage');
        if (this.isMobileDevice) {
            // buttonsBar.style.display = 'none';
            isButtonsVisible = false;
        }
        chatRoomBtn.className = 'fas fa-comment-slash';
        msgerDraggable.style.top = '50%';
        msgerDraggable.style.left = this.isMobileDevice ? '50%' : '25%';
        msgerDraggable.style.display = 'flex';
        isChatRoomVisible = true;
        // only for desktop
        if (!this.isMobileDevice) {
            // this.setTippy(chatRoomBtn, 'Close the chat', 'right-start');
        }
    }


    /**
    * handle Incoming Data Channel Chat Messages
    * @param {object} dataMessage chat messages
    */
    handleDataChannelChat = (dataMessage) => {
        if (!dataMessage) return;

        let msgFrom = dataMessage.from;
        let msgTo = dataMessage.to;
        let msg = dataMessage.msg;
        let msgPrivate = dataMessage.privateMsg;

        // private message but not for me return
        if (msgPrivate && msgTo != myPeerName) return;

        // console.log('handleDataChannelChat', dataMessage);
        // chat message for me also
        if (!isChatRoomVisible) {
            this.showChatRoomDraggable();
            chatRoomBtn.className = 'fas fa-comment-slash';
        }
        // playSound('chatMessage');
        // setPeerChatAvatarImgName('left', msgFrom);
        // appendMessage(msgFrom, leftChatAvatar, 'left', msg, msgPrivate);
    }

    /**
    * Refresh my stream changes to connected peers in the room
    * @param {object} stream media stream audio - video
    * @param {boolean} localAudioTrackChange default false
    */
    // refreshMyStreamToPeers = (stream, localAudioTrackChange = false) => {

    //     let camera = { srcObject: stream, id: "screenShare", local: true }
    //     let cameras = this.props.cameras
    //     this.sharedScreen = { id: "screenShare", streamId: stream.id }
    //     cameras.push(camera)
    //     this.props.setStateProps("cameras", cameras, () => {
    //         if (this.state.isScreenStreaming) {
    //             console.log('!camera', cameras, this.localVideo);
    //             this.setView(async () => {
    //                 let peerConnections = this.props.peerConnections
    //                 for (let peer_id in peerConnections) {
    //                     console.log("peerConnections", peerConnections)
    //                     console.log("peerConnections ID", peerConnections[peer_id])

    //                     stream.getTracks().forEach(track => peerConnections[peer_id].addTrack(track, stream))
    //                     // await this.props.handleOnTrack(peer_id, this.props.allPeers,stream)

    //                 }
    //                 // await this.props.attachMediaStream(this.props.remoteMediaStream, stream); // newstream
    //             })

    //         }
    //     })

    //     // }



    //     // if (!this.thereIsPeerConnections()) return;
    //     // console.log('isscreen', this.state.isScreenStreaming);
    //     // if (this.state.isScreenStreaming) {
    //     //     console.log('true');
    //     //     // this.props.joinToChannel(true)
    //     //     // this.props.handleConnect()
    //     //     let userId
    //     //     let cameras = this.props.cameras
    //     //     cameras.map((camera) => {
    //     //         if (camera.id == 'localVideo') {
    //     //             console.log('local camera', camera);
    //     //             userId = camera.peer?.peer_id
    //     //         }
    //     //     })
    //     //     this.props.initScreenPeer(userId, () => {
    //     //         console.log('user id', userId);
    //     //         setTimeout(() => {
    //     //             this.props.handleScreenShare()
    //     //         }, 200);

    //     //     })
    //     // }
    //     // else {
    //     //     // this.leaveRoom()
    //     // }

    //     // console.log('PEER-CONNECTIONS', this.props.peerConnections); // all peers connections in the room expect myself
    //     // console.log('ALL-PEERS', this.props.allPeers); // all peers connected in the room

    //     // refresh my stream to connected peers expect myself
    //     // for (let peer_id in this.props.peerConnections) {
    //     //     console.log('all peers', this.props.allPeers);
    //     //     let peer_name = this.props.allPeers[peer_id]['peer_name'];
    //     //     console.log('peer name', this.props.allPeers[peer_id]['peer_name']);

    //     //     // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getSenders
    //     //     // let videoSender = this.props.peerConnections[peer_id]
    //     //     //     .getSenders()
    //     //     //     .find((s) => (s.track ? s.track.kind === 'video' : false));
    //     //     // // console.log('CHECK VIDEO SENDER - ' + peer_name, videoSender);

    //     //     // if (videoSender) {
    //     //     //     console.log('videoSender', videoSender);
    //     //     //     // videoSender.getTracks().forEach((track)=>{

    //     //     //     // })
    //     //     //     // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpSender/replaceTrack
    //     //     //     console.log('add VIDEO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    //     //     //     // this.props.handleAddPeer()
    //     //     // } else {
    //     //     //     stream.getTracks().forEach((track) => {
    //     //     //         if (track.kind === 'video') {
    //     //     //             // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/addTrack
    //     //     //             this.props.peerConnections[peer_id].addTrack(track);
    //     //     //             this.props.handleRtcOffer(peer_id); // https://groups.google.com/g/discuss-webrtc/c/Ky3wf_hg1l8?pli=1
    //     //     //             console.log('ADD VIDEO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    //     //     //         }
    //     //     //     });
    //     //     // }


    //     //     if (localAudioTrackChange) {
    //     //         // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getSenders
    //     //         let audioSender = this.props.peerConnections[peer_id]
    //     //             .getSenders()
    //     //             .find((s) => (s.track ? s.track.kind === 'audio' : false));

    //     //         if (audioSender) {
    //     //             // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpSender/replaceTrack
    //     //             audioSender.replaceTrack(stream.getAudioTracks()[0]);
    //     //             console.log('REPLACE AUDIO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    //     //         }
    //     //     }
    //     // }
    // }


    /**
     * Create Chat Room Data Channel
    * @param {string} peer_id socket.id
    */
    createChatDataChannel = (peer_id) => {
        chatDataChannels[peer_id] = peerConnections[peer_id].createDataChannel('mirotalk_chat_channel');
        chatDataChannels[peer_id].onopen = (event) => {
            // console.log('chatDataChannels created', event);
        };
    }

    /**
    * Create File Sharing Data Channel
    * @param {string} peer_id socket.id
    */
    createFileSharingDataChannel = (peer_id) => {
        fileDataChannels[peer_id] = peerConnections[peer_id].createDataChannel('mirotalk_file_sharing_channel');
        fileDataChannels[peer_id].binaryType = 'arraybuffer';
        fileDataChannels[peer_id].onopen = (event) => {
            // console.log('fileDataChannels created', event);
        };
    }

    nameValue = (e) => {
        // console.log(e.target.value)
        myPeerName = e.target.value;
        this.setState({ name: myPeerName })
    }



    // show whiteBoard

    onShowWhiteboard = () => {
        this.setState({ showWhiteboard: !this.state.showWhiteboard })
    }










    screenShare = () => {

        this.toggleScreenSharing()
    }

    showAddPeopleModal = () => {
        // console.log('tp11111')
        // console.log('ams')
        this.addPeopleModal.showModal()
    }

    toggleScreenSharing = async () => {
        // screenMaxFrameRate = parseInt(screenFpsSelect.value);
        // const constraints = {
        //     video: { frameRate: { max: screenMaxFrameRate } },
        // }; // true | { frameRate: { max: screenMaxFrameRate } }
        // let isScreenStreaming = this.state.isScreenStreaming
        let screenMediaPromise = null;
        setTimeout(async () => {

            try {
                // console.log('is streaming', this.state.isScreenStreaming);
                if (!this.state.isScreenStreaming) {
                    // on screen sharing start
                    screenMediaPromise = await navigator.mediaDevices.getDisplayMedia({
                        // video: true
                        video: {
                            width: { ideal: 1024, max: 1920 },
                            height: { ideal: 720, max: 1080 }
                        }
                    })


                    screenMediaPromise.getVideoTracks()[0].onended = () => {
                        // console.log("STOP")
                        this.setState({ isScreenStreaming: false }, async () => {

                            await this.props.UpdateShareScreenToPeers(null)

                        })

                    };

                    // await this.refreshMyStreamToPeers(screenMediaPromise)
                }
                // else {
                //     // on screen sharing stop
                //     screenMediaPromise = await navigator.mediaDevices.getUserMedia({
                //         video: true,
                //         audio: true
                //     });
                // }
                // if (screenMediaPromise) {
                //     console.log("screen media", screenMediaPromise);

                this.setState({ isScreenStreaming: !this.state.isScreenStreaming }, async () => {

                    //         console.log('is streaming', this.state.isScreenStreaming);
                    //         if (this.state.isScreenStreaming) {
                    //             // setMyVideoStatusTrue();
                    //             // if (countPeerConnections() == 1) {
                    //             //     setAspectRatio(2); // 16:9
                    //             // }
                    //             await this.emitPeersAction('screenStart');
                    //             console.log('cameras!', this.props.peerConnections);
                    //         } else {
                    //             await this.emitPeersAction('screenStop');



                    //             // adaptAspectRatio();
                    // }

                    console.log("screenMediaPromise",screenMediaPromise)
                    await this.props.UpdateShareScreenToPeers(screenMediaPromise)
                    // await this.refreshMyLocalStream(screenMediaPromise);
                    //         // await this.refreshMyStreamToPeers(screenMediaPromise);
                    //         // await this.stopLocalVideoTrack();

                })
                //     // myVideo.classList.toggle('mirror');
                //     // setScreenSharingStatus(this.state.isScreenStreaming);
                //     // if (myVideoAvatarImage && !useVideo)
                //     //     myVideoAvatarImage.style.display = this.state.isScreenStreaming ? 'none' : 'block';
                // }
            } catch (err) {
                // console.error('[Error] Unable to share the screen', err);
                // console.log('error', 'Unable to share the screen ' + err);
            }
        }, 10);

    }


    // /**
    // * Refresh my local stream
    // * @param {object} stream media stream audio - video
    // * @param {boolean} localAudioTrackChange default false
    // */
    // refreshMyLocalStream = async (stream, localAudioTrackChange = false) => {
    //     // console.log('screen media promise', stream);
    //     if (this.state.isScreenStreaming) {

    //         if (useVideo) stream.getVideoTracks()[0].enabled = true;

    //         // // enable audio
    //         // if (localAudioTrackChange && myAudioStatus === false) {
    //         //     audioBtn.className = 'fas fa-microphone';
    //         //     setMyAudioStatus(true);
    //         //     myAudioStatus = true;
    //         // }

    //         let newStream = null;

    //         // https://developer.mozilla.org/en-US/docs/Web/API/MediaStream
    //         if (useVideo || this.state.isScreenStreaming) {
    //             // console.log('Refresh my local media stream with video - audio');
    //             // console.log(stream.getVideoTracks());
    //             // newStream = stream
    //             newStream = new MediaStream([
    //                 stream.getVideoTracks()[0],
    //                 localAudioTrackChange ? stream.getAudioTracks()[0] : this.props.localMediaStream.getAudioTracks()[0],
    //             ]);
    //         } else {
    //             // console.log('Refresh my local media stream with audio');
    //             newStream = new MediaStream([
    //                 localAudioTrackChange ? stream.getAudioTracks()[0] : this.props.localMediaStream.getAudioTracks()[0],
    //             ]);
    //         }
    //         // if (!this.state.isScreenStreaming) {

    //         let camera = { srcObject: newStream, id: "screenShare", local: true }
    //         let cameras = this.props.cameras
    //         this.sharedScreen = { id: "screenShare", streamId: stream.id }
    //         cameras.push(camera)
    //         this.props.setStateProps("cameras", cameras, () => {
    //             if (this.state.isScreenStreaming) {
    //                 // console.log('!camera', cameras, this.localVideo);
    //                 this.setView(() => {
    //                 })
    //                 // this.props.attachMediaStream(this.localVideo, newStream); // newstream

    //             }
    //         })

    //         // }
    //     }
    //     else {
    //         let cameras = this.props.cameras
    //         // console.log(cameras)
    //         let cindex
    //         cameras.map((camera, index) => {
    //             // console.log('camera!', camera);
    //             if (camera.id == "screenShare" && camera.srcObject.id == this.sharedScreen.streamId) {
    //                 // console.log('camer----', camera);
    //                 // delete cameras[index]
    //                 cindex = index
    //             }
    //         })

    //         cameras.splice(cindex, 1)

    //         // console.log(cameras)
    //         await this.props.setStateProps("cameras", cameras, async () => {
    //             await this.setView(() => {

    //             })
    //         })
    //     }

    //     // this.setScreenShareView(newStream)
    //     // this.props.setStateProps("localMediaStream", newStream, () => {

    //     //     console.log('newstream', this.props.localMediaStream);
    //     // })

    //     // log newStream devices
    //     // logStreamSettingsInfo('refreshMyLocalStream', localMediaStream);

    //     // start capture mic volumes
    //     // startPitchDetection(localMediaStream);

    //     // attachMediaStream is a part of the adapter.js library

    //     // on toggleScreenSharing video stop
    //     if (useVideo || this.state.isScreenStreaming) {
    //         stream.getVideoTracks()[0].onended = () => {
    //             this.toggleScreenSharing();
    //         };
    //     }

    //     /**
    //      * When you stop the screen sharing, on default i turn back to the webcam with video stream ON.
    //      * If you want the webcam with video stream OFF, just disable it with the button (Stop the video),
    //      * before to stop the screen sharing.
    //      */
    //     // if (myVideoStatus === false) localMediaStream.getVideoTracks()[0].enabled = false;
    // }


    // //     /**
    // //   * Refresh my stream changes to connected peers in the room
    // //   * @param {object} stream media stream audio - video
    // //   * @param {boolean} localAudioTrackChange default false
    // //   */
    // //     refreshMyStreamToPeers = async (stream, localAudioTrackChange = false) => {
    // //         // if (!thereIsPeerConnections()) return;

    // //         console.log('PEER-CONNECTIONS', peerConnections); // all peers connections in the room expect myself
    // //         console.log('ALL-PEERS', allPeers); // all peers connected in the room

    // //         // refresh my stream to connected peers expect myself
    // //         for (let peer_id in peerConnections) {
    // //             let peer_name = allPeers[peer_id]['peer_name'];

    // //             // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getSenders
    // //             let videoSender = peerConnections[peer_id]
    // //                 .getSenders()
    // //                 .find((s) => (s.track ? s.track.kind === 'video' : false));
    // //             console.log('CHECK VIDEO SENDER - ' + peer_name, videoSender);

    // //             if (videoSender) {
    // //                 // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpSender/replaceTrack
    // //                 videoSender.replaceTrack(stream.getVideoTracks()[0]);
    // //                 console.log('REPLACE VIDEO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    // //             } else {
    // //                 stream.getTracks().forEach((track) => {
    // //                     if (track.kind === 'video') {
    // //                         // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/addTrack
    // //                         peerConnections[peer_id].addTrack(track);
    // //                         this.handleRtcOffer(peer_id); // https://groups.google.com/g/discuss-webrtc/c/Ky3wf_hg1l8?pli=1
    // //                         console.log('ADD VIDEO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    // //                     }
    // //                 });
    // //             }

    // //             if (localAudioTrackChange) {
    // //                 // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/getSenders
    // //                 let audioSender = peerConnections[peer_id]
    // //                     .getSenders()
    // //                     .find((s) => (s.track ? s.track.kind === 'audio' : false));

    // //                 if (audioSender) {
    // //                     // https://developer.mozilla.org/en-US/docs/Web/API/RTCRtpSender/replaceTrack
    // //                     audioSender.replaceTrack(stream.getAudioTracks()[0]);
    // //                     console.log('REPLACE AUDIO TRACK TO', { peer_id: peer_id, peer_name: peer_name });
    // //                 }
    // //             }
    // //         }
    // //     }






    /**
      * Stop Local Video Track
      */
    stopLocalVideoTrack = async () => {
        if (useVideo || !this.state.isScreenStreaming) this.props.localMediaStream.getVideoTracks()[0].stop();
    }


    // showOptions = (index) => {
    //     let option = this.state.option
    //     if (!option[index]) {
    //         option[index] = false
    //     }
    //     option[index] = !option[index]
    //     this.setState({ option })
    //     this.personFixedView.showView()
    // }

    setLayout = (target) => {
        console.log('heereeeeeee', target)
        this.setState({ checked: target })
    }

    raiseHand = () => {
        let hand = this.state.hand
        this.setState({ hand: !hand })
    }

    onStickerSelect = (type, prop) => {
        // let emojis = this.state.emojis ?? {}
        // if (Object.values(emojis).length < 10) {
        //     let id = nanoid()
        //     let left = Math.floor(Math.random() * 101) + 5;
        //     emojis[id] = { time: 2, left, type: prop.emoji, id }

        //     this.setState({ emojis }, () => {
        //         // console.log(this.state.emoji, 'emoji')
        //         setTimeout(() => {
        //             delete emojis[id]
        //             this.setState({ emojis })
        //         }, 5000);
        //     })
        // }

        console.log(type, prop)

        this.props.sendEmojiToPeers(prop.emoji)
    }






    showHubsList = () => {

        this.setState({ showInformation: false }, () => {

            this.roomHubsList.toggle(() => {
                this.setView()
            })
        })

    }

    toggleInformation = () => {

        this.roomHubsList.close()

        this.setState({ showInformation: !this.state.showInformation }, () => {
            this.setView()
        })
    }


    render() {
        let option = this.state.option
        let emojis = this.props.emojis ? Object.values(this.props.emojis) : []
        return (
            <>
                {this.state.showWhiteboard && (
                    <WhiteBoard myPeerName={myPeerName} />
                )}
                <div className="h-100 window-content-radius" height='100%' style={{ backgroundColor: "#f6f6f6" }}>
                    <div height="100" className="h-100 d-flex flex-row">





                        <div height="100" className="room-main-video-container window-content-radius h-100" style={{ zIndex: 2, position: 'relative' }}>





                            {this.props.joinPendingRequests?.length > 0 && (
                                <>
                                    {this.props.joinPendingRequests.map((request, index) => {
                                        if (index == 0) {
                                            return (
                                                // <div className="col-12 col-md-6 col-lg-4 mb-4" key={request.id}>
                                                <RequestToJoinMeeting approveRequest={this.props.approveRequest} data={request} language={this.props.language} isLoadingApproveRequest={this.props.isLoadingApproveRequest} />
                                                // </div>

                                            )
                                        }
                                    })
                                    }
                                </>
                            )}


                            <div className="w-100 h-100 cameras-container" ref={el => this.camerasContainer = el}>
                                {/* {console.log(this.props.cameras)} */}






                                {this.props.cameras.map((camera, index) => {
                                    let position = this.state.positions[index]
                                    if (position) {
                                        if (camera.local && !camera.screenShare) {
                                            return (
                                                <div id={"localVideo_videoWrap"} key={camera.id} className="camera-container" style={{ top: position.top, left: position.left, width: position.w, height: position.h, zIndex: 10, border: '1px solid #ffffff90' }}>
                                                    <div className="w-100 h-100 position-relative flexcc">


                                                        <div className="person-name-container">
                                                            <p className="">{camera.peer?.name ?? camera.peer?.peer_name}</p>
                                                            {!this.props.useAudio &&
                                                                <img className="mld-1" src="/assets/icons/rooms/mic-off.svg" width={18} alt="" />
                                                            }
                                                            {this.props.myHandStatus &&
                                                                <img className="mld-1" src="/assets/icons/rooms/hand.svg" width={18} alt="" />
                                                            }
                                                            {this.state.emoji &&
                                                                <p className="mld-1">{this.state.emoji}</p>
                                                            }
                                                        </div>
                                                        <video id="local-video" className="local-video  w-100 h-100" style={{ backgroundColor: this.props.videoOff ? '#000' : '#b6b6b6' }} srcobject={camera.srcObject} muted playsInline autoPlay={true} ref={vid => this.localVideo = vid}></video>
                                                        {(!this.props.useVideo && !camera.screenShare) && (
                                                            <div className="flex-1 w-100 h-100 position-absolute top-0 left-0 br-8 flexcc px-2 py-2" style={{ background: '#000' }}>
                                                                <p className="text-bold text-white">{translate("Camera is off")}</p>
                                                            </div>

                                                        )}
                                                        <img className="profile-img" src={imageAddress(this.props.user?.image, 'profile', 'thumb')} height={100} width={100} style={{ display: this.props.videoOff ? 'flex' : 'none', borderRadius: '100px', position: 'absolute' }} alt="" />

                                                    </div>
                                                </div>
                                            )
                                        }
                                        // else if () {

                                        // }
                                        else {
                                            // console.log(camera)
                                            return (
                                                <div ref={el => this[camera.id + '_videoWrap'] = el} id={camera.id + '_videoWrap'} key={camera.id} className="camera-container" style={{ top: position.top, left: position.left, width: position.w, height: position.h }}>
                                                    <div className="w-100 h-100 position-relative">
                                                        <div className="person-name-container">
                                                            <p className="">{camera.peer?.name}</p>
                                                            {(!camera.peer_audio && !camera.screenShare) &&
                                                                <img className="mld-1" src="/assets/icons/rooms/mic-off.svg" width={18} alt="" />
                                                            }
                                                            {camera.peer_hand &&
                                                                <img className="mld-1" src="/assets/icons/rooms/hand.svg" width={18} alt="" />
                                                            }
                                                            {camera.peer_emoji &&
                                                                <p className="mld-1">{camera.peer_emoji}</p>
                                                            }
                                                        </div>
                                                        <video id={camera.id + '_video'} className={"w-100 h-100 " + (camera.screenShare ? 'screenshare-camera' : 'peer-camera')} srcobject={camera.srcObject} playsInline autoPlay={true} ref={vid => this[camera.id] = vid} ></video>
                                                        {(!camera.peer_video && !camera.screenShare) && (
                                                            <div className="flex-1 w-100 h-100 position-absolute top-0 left-0 br-8 flexcc px-2 py-2" style={{ background: '#000' }}>
                                                                <img className="br-30" src={imageAddress(camera.peer?.image, 'hub', 'thumb')} height={50} width={50} alt="" style={{ border: '1px solid #ffffff50', objectFit: 'cover' }} />
                                                            </div>

                                                        )}

                                                    </div>
                                                </div>
                                            )
                                        }
                                    }
                                })}
                            </div>
                            <div className="emoji-container" style={{ position: 'absolute', left: 15, bottom: 70, width: '100px', height: '400px', maxHeight: this.props.height - 200, zIndex: 99 }}>
                                <div className="" style={{ positions: 'relative' }}>
                                    {emojis.map((prop, index) => {
                                        let isLastPeersEmoji = true
                                        if (emojis[index + 1]?.peer?.peer_id == prop.peer?.peer_id) isLastPeersEmoji = false
                                        return (
                                            <div className="flexcc flex-column emojis-animat" key={prop.id} style={{ left: prop.left, bottom: 0, position: 'absolute', }}>
                                                <p className="font-size-30 "  >{prop.type}</p>
                                                <div className="position-relative flexcc">
                                                    {(prop.peer?.peer_name && isLastPeersEmoji) && (
                                                        <div className="font-size-11 br-20 px-1 position-absolute top-0" style={{ background: '#000', opacity: 0.5, maxWidth: 100 }}>
                                                            <p className=" w-100 white" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{checkTranslation(prop.peer?.peer_name)}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>




                        <div className={this.state.showInformation ? "h-100 scroll-no-scrollbar peoplesListOn pb-5" : "h-100 pb-2 scroll-no-scrollbar peoplesListOff pb-5"} >
                            <div className="d-flex flex-column px-2 py-2">
                                <p className="mb-2 mt-1 font-size-18 weight-600 window-content-radius" style={{ color: '#4F4F4F', position: 'sticky', top: 0, }}>{translate('rooms.Information')}</p>
                                <div className="flexc mb-2">
                                    <img width={24} src="/assets/icons/rooms/room-name.svg" alt="" />
                                    <p className="font-size-12 mld-1" style={{ color: '#717D8A' }}>{translate('rooms.Room name')}</p>
                                </div>
                                {/* <p className="font-size-14 weight-500 cursor-pointer pb-3 mld-2" style={{ color: '#4F5B67' }}>{this.state.path}</p> */}
                                <div className="flexc">
                                    <img width={24} src="/assets/icons/rooms/creator.svg" alt="" />
                                    <p className="font-size-12 mld-1" style={{ color: '#717D8A' }}>{translate('rooms.Creator')}</p>
                                </div>
                                <p className="font-size-14 weight-500  pb-3 mld-2" style={{ color: '#4F5B67' }}>{this.props.user.fullname}</p>
                                <div className="flexc">
                                    <img width={24} src="/assets/icons/rooms/creat-date.svg" alt="" />
                                    <p className="font-size-12 mld-1" style={{ color: '#717D8A' }}>{translate('rooms.Date created')}</p>
                                </div>
                                <p className="font-size-14 weight-500  pb-3 mld-2" style={{ color: '#4F5B67' }}>20May, 2022</p>
                                <div className="flexc">
                                    <img width={24} src="/assets/icons/rooms/members-purple.svg" alt="" />
                                    <p className="font-size-12 mld-1" style={{ color: '#717D8A' }}>{translate('rooms.Members')}</p>
                                </div>
                                <p className="font-size-14 weight-500  pb-3 mld-2" style={{ color: '#4F5B67' }}>{this.props.uniqueHubs ? Object.values(this.props.uniqueHubs).length : 1} {translate('rooms.persons')}</p>
                                <div className="flexc">
                                    <img width={24} src="/assets/icons/rooms/room-timer.svg" alt="" />
                                    <p className="font-size-12 mld-1" style={{ color: '#717D8A' }}>{translate('rooms.Room timer')}</p>
                                </div>
                                <p className="font-size-14 weight-500  mld-2" style={{ color: '#4F5B67' }}>00:20:15</p>
                            </div>
                        </div>


                        <RoomHubsList uniqueHubs={this.props.uniqueHubs} ref={el => this.roomHubsList = el} joinPendingRequests={this.props.joinPendingRequests} approveRequest={this.props.approveRequest} isLoadingApproveRequest={this.props.isLoadingApproveRequest} />

                        {/* <div className={this.props.peopleList ? " scroll-no-scrollbar peoplesListOn window-content-radius" : "peoplesListOff"}>
                            <div className="d-flex flex-column w-100 px-2 pb-3">
                                <div className="flexcb w-100 pt-3 mb-2" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                                    <p className="font-size-16 weight-600" style={{ color: '#4F4F4F' }}>{translate('rooms.Participants list')}</p>
                                    <button className="flexc hover-gray br-10 p-1" style={{ width: '30px', height: '30px' }} onClick={() => this.showAddPeopleModal()}>
                                        <img src="/assets/icons/rooms/add-people.svg" className="w-100" />
                                    </button>
                                </div>

                                <div className='flexcb br-10 w-100 p-2 mb-2 navbar-search-simple' style={{ backgroundColor: '#eee' }}>
                                    <img src='/assets/icons/search-gray.svg' width={18} />
                                    <input className='input w-100 font-size-14' placeholder={translate('rooms.Search for people')} />
                                </div>


                                <div className="" style={{ paddingBottom: '56px' }}>
                                    <p className="font-size-14 pb-1 mt-1 text-semibold" style={{ color: '#717D8A' }}>{translate('Contributors')}</p>
                                    {this.props.uniqueHubs && Object.values(this.props.uniqueHubs).map((item, index) => {
                                        return (
                                            <div className="unSelectMember flexc flex-column my-2 py-1" key={item.peer_userId ?? index}>
                                                <div className={" w-100 flexcb "}>
                                                    <div className={" flexc cursor-pointer "} onClick={() => this.setState({ currentMember: item })} style={{}}>
                                                        <img src={imageAddress(item.peer_image, 'hub', 'mini')} width={30} height={30} className="mrd-3 br-20 image-cover" alt="" />
                                                        <p className="font-size-14 weight-500 cursor-pointer" style={{ color: '#4F5B67' }}>{item.peer_name}</p>
                                                    </div>
                                                    <button className="flexcc" onClick={() => { this.showOptions(index) }} ref={e => this.personNodeRef = e} >
                                                        <img width={24} className={" invert opacity-5 " + (this.state.option[index] ? 'optionImage' : '')} src='/assets/icons/rooms/more.svg' alt="" />
                                                    </button>
                                                </div>
                                                {this.state.option[index] &&
                                                    <FixedView ref={el => this.personFixedView = el} width={this.props.width} nodeRef={this.personNodeRef} zIndex={1000} bottomOffset={30} maxWidth={240}>
                                                        <div className='sc-1 shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", }}>
                                                            {this.state.hubsMore.map((prop, index) => {
                                                                return (
                                                                    <div className="bb-gray mt-1 pb-1">
                                                                        <div className="flexc w-100 optionMember pt-3" style={{ zIndex: 100 }}>
                                                                            <button className="flexc">
                                                                                <img src='/assets/icons/rooms/microphone-off-red.svg' className="mrd-2" alt="" />
                                                                                <p style={{ color: '#DB302A' }}>{translate(prop.title)}</p>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </FixedView>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <RoomControl onStickerSelect={this.onStickerSelect} hand={this.state.hand} raiseHand={this.raiseHand} language={this.props.language} stream={this.props.localMediaStream} setLayout={this.setLayout} checked={this.state.checked} useVideo={this.props.useVideo} useAudio={this.props.useAudio} myHandStatus={this.props.myHandStatus} setData={this.props.setData} screenShare={this.toggleScreenSharing} toggleMuteAudio={this.props.toggleMuteAudio} toggleRaiseHand={this.props.toggleRaiseHand} toggleStopCamera={this.props.toggleStopCamera} isScreenStreaming={this.state.isScreenStreaming} onShowWhiteboard={this.onShowWhiteboard} leaveRoom={this.leaveRoom} width={this.props.width} showHubsList={this.showHubsList} setInformation={this.toggleInformation} showSettingsModal={this.showSettingsModal} localMediaStream={this.props.localMediaStream} peerConnections={this.props.peerConnections} />

                </div>



                <Modal maxWidth={400} maxHeight={400} className="" ref={(e) => this.addPeopleModal = e}  >
                    <div className='d-flex w-100 h-100 window-content-radius flexcc'>
                        <div className="laterLinkModal px-3 py-4 w-100 " style={{}}>
                            <div className="w-100 flexcb">
                                <p className='font-size-15 weight-500 pb-2'>{translate('rooms.Add people')}</p>
                                <button className="flexc hover-gray br-10 py-1 px-2">
                                    <p className="font-size-14 main-c7">{translate('rooms.Invite')}</p>
                                    <img src="/assets/icons/rooms/add-purple.svg" width={25} />
                                </button>
                            </div>
                            <div className="w-100 my-1">
                                <input className='copyLinkRoom w-100 br-10 py-2 px-2 font-size-14' name='link' id='link' placeholder={translate('rooms.Enter name or Email')} />
                            </div>
                            <div className="w-100 pb-1">
                                <p className="font-size-14">{translate('rooms.Suggestions')}</p>
                            </div>
                            <div className="w-100 scroll-no-scrollbar" style={{ maxHeight: '300px' }}>
                                {this.state.people.map((item, index) => {
                                    return (
                                        <div className="w-100 flexcb px-2" key={item._id}>
                                            <div className="flexc my-2 py-1 px-1 " style={{}}>
                                                <img src={item.img} width={30} className="mrd-3" style={{}} />
                                                <p className="font-size-14" style={{ color: '#4F5B67' }}>{item.name}</p>
                                            </div>
                                            <img src='/assets/icons/rooms/add-purple.svg' />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }



    playSound = async (name) => {
        if (!notifyBySound) return;
        let sound = '/sounds/' + name + '.mp3';
        let audioToPlay = new Audio(sound);

        try {
            await audioToPlay.play();
        } catch (err) {
            // console.error("Cannot play sound", err);
            // Automatic playback failed. (safari)
            return;
        }
    }



    leaveRoom = () => {

        if (this.props.stream) {
            // console.log('this.props.stream', this.props.stream)
            // console.log('this.props.roomId', this.props.roomId)
            // console.log('this.props`', this.props)
            let obj = { roomId: this.props.roomId, type: 'acceptCall' }
            store.dispatch(actions.removeCall([obj]))
            // console.log('stream', this.props.stream);
            // this.playSound('eject');

            this.props.stream.getTracks().forEach(function (track) {
                // console.log(track)
                track.stop();
                // this.props.stream.removeTrack(track)
            });

            // navigator.mediaDevices.getUserMedia({ video: false, audio: false });

            // this.stream = null
            this.props.setStateProps("stream", null, () => {
                // console.log('newstream1', this.props.stream);
                if (this.localVideo) {
                    this.localVideo.srcObject = null;
                }

                // localMediaStream.getTracks().forEach(function (track) {
                //     track.stop();
                // });


                this.props.sendToServer('roomLeave', { roomId: this.props.roomId });
                // console.log('here');
                setTimeout(() => {
                    this.props.goToReview()
                }, 500);
            })
            // if (surveyActive) {
            //     openURL(surveyURL);
            // } else {
            //     openURL('/newcall');
            // }
        }
    }

}
// const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default RoomVideo